import { LevelType, SpaceType } from 'data/types';

export function isConditionedSpace(space: SpaceType): boolean {
  return space.conditioned !== false;
}

export function getConditionedSpaces(structure: LevelType[]): SpaceType[] {
  return structure.flatMap((level) =>
    level.sections.flatMap((section) =>
      section.spaces.filter(isConditionedSpace)
    )
  );
}

export function getUnconditionedSpaces(structure: LevelType[]): SpaceType[] {
  return structure.flatMap((level) =>
    level.sections.flatMap((section) =>
      section.spaces.filter((space) => !isConditionedSpace(space))
    )
  );
}
